import { render, staticRenderFns } from "./SettingsCreateHolder.vue?vue&type=template&id=4d921b69&scoped=true"
import script from "./SettingsCreateHolder.vue?vue&type=script&lang=js"
export * from "./SettingsCreateHolder.vue?vue&type=script&lang=js"
import style0 from "./SettingsCreateHolder.vue?vue&type=style&index=0&id=4d921b69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d921b69",
  null
  
)

export default component.exports